import { render, staticRenderFns } from "./MapCard.vue?vue&type=template&id=4c12f831&"
import script from "./MapCard.vue?vue&type=script&lang=js&"
export * from "./MapCard.vue?vue&type=script&lang=js&"
import style0 from "./MapCard.vue?vue&type=style&index=0&id=4c12f831&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports